const capitalizeEveryWord = (str) => {
  if (!str) {
    return "";
  }
  return str.toLowerCase().replace(/\b[a-z]/g, (char) => char.toUpperCase());
};
export default capitalizeEveryWord;
